import { createContext } from 'react';

const consultationContext = createContext();

export default consultationContext;

